import React from "react"
import Layout from "layouts/Base"

export default () => (
  <Layout>
    <h1>There was an error.</h1>
    <h3 style={{ color: "rgba(0,0,0,.3)" }}>
      Please reload the page to resume.
    </h3>
    {/* <p>Sorry for the inconvience. The error has been sent to our development team.</p> */}
  </Layout>
)
